import { Button, Typography } from 'antd';
import {
  StyledModal,
  FormSaveButton,
  FormCancelButton,
} from 'common/components';
import { WarnIcon } from 'common/components/dialog-function/DialogIcon';
import { useSaveWalmartFormValueWhenExit } from 'pages/branded-products/components/post-to-walmart-krogger/queries';

const { Text } = Typography;

const WalmartConfirmUpdateModal = ({
  visible,
  onCancel,
  onSaveAndExit,
  onExitWithoutSaving,
}) => {
  const { isSaveFormWalmartMutating } = useSaveWalmartFormValueWhenExit();
  const modalProps = {
    visible,
    onCancel,
    destroyOnClose: true,
    maskClosable: false,
    bodyStyle: {
      textAlign: 'center',
    },
    width: '450px',
    footer: (
      <>
        <FormSaveButton
          onClick={onSaveAndExit}
          text={'Save & Exit'}
          loading={isSaveFormWalmartMutating}
        />
        <Button type='primary' onClick={onExitWithoutSaving}>
          Exit Without Saving
        </Button>
        <FormCancelButton onClick={onCancel} />
      </>
    ),
  };

  return (
    <StyledModal {...modalProps}>
      <WarnIcon />
      <Text style={{ textAlign: 'center', color: '#6c757d', fontSize: '16px' }}>
        You have unsaved changes. Are you sure want to save before exiting?
      </Text>
    </StyledModal>
  );
};

export default WalmartConfirmUpdateModal;
